<template>
  <f7-page>
    <div class="layoutTop"/>
    <div class="container-fluid">
      <div class="row">
        <div class="col-md-10 col-md-10 offset-md-1">
          <b-row>
            <div class="panel21 panel-default">

              <div class="panel-heading">
                  <h4 v-if="idReglesMetier"
                    class="content-block labelAccordionForm">
                      <img src="../../assets/static/images/icons/gearwheels.png" class="formIcon"/>
                      {{$t('regles_metier.edit_rules')}}
                  </h4>
                  <h4 v-else
                    class="content-block labelAccordionForm">
                      <img src="../../assets/static/images/icons/gearwheels.png" class="formIcon"/>
                      {{$t('regles_metier.new_rules')}}
                  </h4>
              </div>

              <!-- Champs du formulaire -->
              <regles-form :hideInterests="true" :sections="true" :v-model="reglesMetier" :value="reglesMetier"/>

            </div>
          </b-row>
          <div class="row">
            <div class="col-md" v-bind:class="colorBottomButton">
              <!-- Loading (update/create) -->
              <button round v-if="loadingDelete"
              class="button-action firstButtonMarginTop">
                <spinner/>
              </button>
              <!-- Delete -->
              <span v-else>
                <button round v-if="idReglesMetier"
                class="button-action firstButtonMarginTop"
                @click="deleteRegleMetier">
                  <i class="icon fa fa-times"></i>
                  <span>Delete</span>
                </button>
              </span>
            </div>
            <div class="col-md" v-bind:class="colorBottomButton">
              <!-- Loading (update/create) -->
              <button round v-if="loadingSave"
              class="button-action firstButtonMarginTop">
                <spinner/>
              </button>
              <span v-else>
                <!-- Update -->
                <button round v-if="idReglesMetier"
                class="button-action firstButtonMarginTop"
                @click="updateReglesMetier">
                  <i class="icon fa fa-save"></i>
                  <span>Edit</span>
                </button>
                <!-- Create -->
                <button round v-else
                class="button-action firstButtonMarginTop"
                @click="createRegleMetier">
                  <i class="icon fa fa-save"></i>
                  <span>Save</span>
                </button>
              </span>
            </div>
          </div>
        </div>
      </div>
      <div class="toolbarPageBottomBlank"></div>
    </div>
  </f7-page>
</template>

<script>
import spinner from '@/components/common/spinner.vue'
import { loadPage } from '@/helpers/routing'
import ReglesForm from './EcheancierReglesForm.vue'

export default {
  name: 'SettingsEcheancier',
  props: ['id'],
  components: {
    spinner,
    'regles-form': ReglesForm
  },
  data () {
    return {
      colorBottomButton: this.$engine.services.getButtonClassColorById(this.$engine.user.currentService.id),
      reglesMetier: this.$engine.reglesMetier.defaultData(),
      loadingSave: false,
      loadingDelete: false
    }
  },
  created () {
    this.idReglesMetier = this.id
    if (this.idReglesMetier) {
      this.getRegleMetier()
    }
  },
  methods: {
    createRegleMetier () {
      let that = this
      if (this.reglesMetier.nom.length > 64) {
        this.$f7.alert(this.$t('regles_metier.name_len'), 'Invalid')
        return
      }
      // transform the number into a 2 decimals number if it's a floating number
      if (this.reglesMetier.montant) {
        if (typeof this.reglesMetier.montant === 'number') {
          this.reglesMetier.montant = this.reglesMetier.montant.toString()
        }
        this.reglesMetier.montant = parseFloat(parseFloat(this.reglesMetier.montant.replace(/\s/g, '')).toFixed(2))
        if (this.reglesMetier.montant.toString().length > 14) {
          this.$f7.alert(this.$t('regles_metier.amnt_len'), 'Invalid')
          return
        }
      }

      const intervalleTotalSec = this.intervalleToSec(this.reglesMetier.intervalle)
      const delaisTotalSec = this.intervalleToSec(this.reglesMetier.delaisTotal)
      if (intervalleTotalSec > 0 && delaisTotalSec > 0 && intervalleTotalSec > delaisTotalSec) {
        this.$f7.alert('Time between installments should not be superior to time until last installment', 'Invalid')
        return
      }

      this.loadingSave = true
      this.$engine.reglesMetier.create({
        'nom': this.reglesMetier.nom,
        'montant': parseFloat(this.reglesMetier.montant),
        'nbEcheancesMin': this.reglesMetier.nbEcheances.min,
        'nbEcheancesMax': this.reglesMetier.nbEcheances.max,
        'montantMinEcheanceType': this.reglesMetier.montantMinEcheanceType,
        'montantMinEcheancePercent': this.reglesMetier.montantMinEcheancePercent,
        'montantMinEcheanceDevise': this.reglesMetier.montantMinEcheanceDevise,
        'intervalleJour': this.reglesMetier.intervalle.jour,
        'intervalleMois': this.reglesMetier.intervalle.mois,
        'intervalleAnnee': this.reglesMetier.intervalle.annee,
        'delaisTotalJour': this.reglesMetier.delaisTotal.jour,
        'delaisTotalMois': this.reglesMetier.delaisTotal.mois,
        'delaisTotalAnnee': this.reglesMetier.delaisTotal.annee,
        'tauxInterets': this.reglesMetier.tauxInterets,
        'formule': this.reglesMetier.formule
      }).then(response => {
        // this.idReglesMetier = response.data.idReglesMetier
        that.$f7.alert(this.$t('regles_metier.saved_message', {name: response.data.nom, amount: response.data.montant}), this.$t('regles_metier.saved'))
      }).catch(err => {
        let message = this.getTextError(err) // mixins errorHandlerMixins
        if (message !== '') {
          that.$f7.alert(message, this.$t('regles_metier.errors'))
        }
      }).finally(() => {
        that.loadingSave = false
      })
    },
    updateReglesMetier () {
      let that = this
      if (this.reglesMetier.nom.length > 64) {
        this.$f7.alert(this.$t('regles_metier.name_len'), 'Invalid')
        return
      }
      if (this.reglesMetier.montant.length > 14) {
        this.$f7.alert(this.$t('regles_metier.amnt_len'), 'Invalid')
        return
      }
      this.reglesMetier.montant = parseFloat(this.reglesMetier.montant).toFixed(2)
      this.loadingSave = true
      this.$engine.reglesMetier.update({
        'idReglesMetier': this.reglesMetier.idReglesMetier,
        'nom': this.reglesMetier.nom,
        'montant': this.reglesMetier.montant,
        'nbEcheancesMin': this.reglesMetier.nbEcheances.min,
        'nbEcheancesMax': this.reglesMetier.nbEcheances.max,
        'montantMinEcheanceType': this.reglesMetier.montantMinEcheanceType,
        'montantMinEcheancePercent': this.reglesMetier.montantMinEcheancePercent,
        'montantMinEcheanceDevise': this.reglesMetier.montantMinEcheanceDevise,
        'intervalleJour': this.reglesMetier.intervalle.jour,
        'intervalleMois': this.reglesMetier.intervalle.mois,
        'intervalleAnnee': this.reglesMetier.intervalle.annee,
        'delaisTotalJour': this.reglesMetier.delaisTotal.jour,
        'delaisTotalMois': this.reglesMetier.delaisTotal.mois,
        'delaisTotalAnnee': this.reglesMetier.delaisTotal.annee,
        'tauxInterets': this.reglesMetier.tauxInterets,
        'formule': this.reglesMetier.formule
      }).then(response => {
        // this.idReglesMetier = response.data.idReglesMetier
        that.$f7.alert(this.$t('regles_metier.saved_message', {name: response.data.nom, amount: response.data.montant}), this.$t('regles_metier.saved'))
      }).catch(err => {
        let message = this.getTextError(err) // mixins errorHandlerMixins
        if (message !== '') {
          that.$f7.alert(message, this.$t('regles_metier.errors'))
        }
      }).finally(() => {
        that.loadingSave = false
      })
    },
    getRegleMetier () {
      let that = this
      this.$engine.reglesMetier.get(this.idReglesMetier)
      .then(response => {
        const {idReglesMetier, nom, montant, nbEcheances, montantMinEcheanceType, montantMinEcheancePercent, montantMinEcheanceDevise,
        intervalle, delaisTotal, tauxInterets, formule} = response.data.reglesMetier[0]
        this.reglesMetier.idReglesMetier = idReglesMetier
        this.reglesMetier.nom = nom
        this.reglesMetier.montant = montant
        this.reglesMetier.nbEcheances.min = nbEcheances.min
        this.reglesMetier.nbEcheances.max = nbEcheances.max
        this.reglesMetier.montantMinEcheanceType = montantMinEcheanceType
        this.reglesMetier.montantMinEcheancePercent = montantMinEcheancePercent
        this.reglesMetier.montantMinEcheanceDevise = montantMinEcheanceDevise
        this.reglesMetier.intervalle.jour = intervalle.jour
        this.reglesMetier.intervalle.mois = intervalle.mois
        this.reglesMetier.intervalle.annee = intervalle.annee
        this.reglesMetier.delaisTotal.jour = delaisTotal.jour
        this.reglesMetier.delaisTotal.mois = delaisTotal.mois
        this.reglesMetier.delaisTotal.annee = delaisTotal.annee
        this.reglesMetier.tauxInterets = tauxInterets
        this.reglesMetier.formule = formule
      })
      .catch(err => {
        let message = this.getTextError(err) // mixins errorHandlerMixins
        if (message !== '') {
          that.$f7.alert(message, this.$t('errors.error_label'))
        }
      })
    },
    deleteRegleMetier () {
      let that = this
      this.loadingDelete = true
      this.$engine.reglesMetier.delete(this.reglesMetier.idReglesMetier)
      .then(response => {
        that.$f7.alert(``, 'Règle métier supprimée')
        loadPage(this, {url: '/settings/echeancier'})
      })
      .catch(err => {
        let message = this.getTextError(err) // mixins errorHandlerMixins
        if (message !== '') {
          that.$f7.alert(message, this.$t('regles_metier.errors'))
        }
      }).finally(() => {
        this.loadingDelete = false
      })
    },
    intervalleToSec (timeObj) {
      const jours = timeObj.jour === '' ? 0 : parseInt(timeObj.jour)
      const mois = timeObj.mois === '' ? 0 : parseInt(timeObj.mois)
      const annees = timeObj.annee === '' ? 0 : parseInt(timeObj.annee)
      return jours + mois * 30 + annees * 365
    }
  }
}
</script>

<style lang="css" scoped>

hr {
  margin-top: 30px;
  margin-bottom: 30px;
}

.input-group-text {
  font-size: small;
}

</style>



// WEBPACK FOOTER //
// SettingsEcheancierRegles.vue?5ffa4272